module.exports = __webpack_public_path__ + "img/ru_success_7.dbb44ca9.png";